var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TwTableFilterBar',{attrs:{"filterModel":_vm.filterForm,"filterChips":_vm.filterChips},on:{"apply":_vm.applyFilter},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var searchForm = ref.model;
return undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }